import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CrownIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="crown" ref={ref} {...props}>
      <path d="M21.37,7.75a.74.74,0,0,0-.84,0L17.72,9.54,16,5.19a.76.76,0,0,0-.58-.46.75.75,0,0,0-.7.27L12,8.32,9.3,5a.72.72,0,0,0-.69-.27A.76.76,0,0,0,8,5.19L6.28,9.54,3.47,7.73a.74.74,0,0,0-.84,0,.75.75,0,0,0-.3.78l2,8.45v0c.26,2.06,5.39,2.29,7.63,2.29s7.37-.23,7.63-2.29v0l2-8.45A.75.75,0,0,0,21.37,7.75ZM12,17.79c-3.65,0-5.68-.6-6.11-1C6.36,16.26,9,15.32,12,15.32s5.63.94,6.11,1.49C17.68,17.19,15.65,17.79,12,17.79Zm6.5-2.52A14.15,14.15,0,0,0,12,13.82a14.15,14.15,0,0,0-6.5,1.45L4.23,10l2,1.29a.78.78,0,0,0,.63.09.74.74,0,0,0,.47-.44l1.61-4,2.46,3,.13.13a.41.41,0,0,0,.11.07l.09.05a.72.72,0,0,0,.54,0l.09-.05a.63.63,0,0,0,.22-.18l0,0,2.46-3,1.61,4a.74.74,0,0,0,.46.44.73.73,0,0,0,.64-.09l2-1.29Z" />
    </Icon>
  ),
) as IconWithRender;

CrownIcon.displayName = 'CrownIcon';
CrownIcon.renderIcon = (props) => <CrownIcon {...props} />;
export default CrownIcon;
